<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Medições"
    >
        <rkm-tabs>
            <rkm-tab title="Gestação">
                <BoxGestacao :data="data" />
            </rkm-tab>

            <rkm-tab title="Antropometria">
                <BoxAntropometria
                    :data="data"
                    :readonly="readonly"
                />
            </rkm-tab>

            <rkm-tab title="Sinais vitais">
                <BoxSinalVital :data="data" />
            </rkm-tab>

            <rkm-tab title="Glicemia capilar">
                <BoxGlicemiaCapilar :data="data" />
            </rkm-tab>
        </rkm-tabs>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import BoxAntropometria from './components/antropometria/Index'
import BoxGestacao from './components/gestacao/Index'
import BoxGlicemiaCapilar from './components/glicemia-capilar/Index'
import BoxSinalVital from './components/sinal-vital/Index'

export default {
    components: {
        BoxAntropometria,
        BoxGestacao,
        BoxGlicemiaCapilar,
        BoxSinalVital,
    },
    methods: {
        open() {
            this.$refs.RkmModal.show()
        },
    },
    props: {
        data: {required: true, type: Object},
        readonly: {type: Boolean, default: false}
    },
}
</script>